import { Skeleton } from "antd";
import { useMyContext } from "../../../../entities/context";
import { TopBar } from "../../../../widgets";


const MyEventSkeleton = () => {
    const { topHeight } = useMyContext();

    return (<>
        <TopBar title="이벤트" rightIcon={false} />
        <div style={{ maxWidth: "456px", backgroundColor: 'white', paddingTop: (topHeight + 'px'), padding: '0 24px' }}>
            <div style={{ width: '100%', textAlign: 'center', marginTop: '13px' }}>
                <div style={{ width: '100%', display: 'inline-block' }}>
                    <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 21 }} />
                </div>
            </div>
            <div style={{ width: '100%', marginTop: '45px' }}>
                <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 200 }} />
            </div>

            <div style={{ width: '100%', marginTop: '16px' }}>
                <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 22 }} />
                <div style={{ marginTop: 4, width: '160px' }}>
                    <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 22 }} />
                </div>
            </div>

            <div style={{ width: '100%', marginTop: '32px' }}>
                <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 200 }} />
            </div>

            <div style={{ width: '100%', marginTop: '16px' }}>
                <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 22 }} />
                <div style={{ marginTop: 4, width: '100%' }}>
                    <Skeleton.Button active={true} size={"default"} block={true} style={{ height: 22 }} />
                </div>
            </div>
        </div>
    </>
    )
}

export default MyEventSkeleton;